<template>
  <v-card flat>
    <v-card-text class="d-flex justify-center">
      <div class="d-flex flex-row">
        <v-avatar color="teal lighten-5" size="140" class="mx-3">
          <v-avatar color="teal" size="120">
            <v-icon color="white" size="70">mdi-file-sign</v-icon>
          </v-avatar>
        </v-avatar>
        <div style="max-width: 50ch" class="mt-4 text-body-1">
          <p class="academic">
            I hereby declare that to the best of my knowledge all the
            information I have provided on this form and all supporting
            documents are true and correct and I agree to abide by the
            Examination Rules and Regulations and Code of Conduct and Ethics for
            KISEB.
          </p>
          <div class="d-flex flex-column align-end">
            <div class="d-flex flex-row">
              <v-form v-model="isValid" ref="submitAppForm">
                <v-checkbox
                  color="primary"
                  v-model="agree"
                  label="I Agree"
                  :rules="rules.required"
                ></v-checkbox>
              </v-form>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
import RouterMixin from "@brainspore/celadon-base/mixin/RouterMixin";
import { AuthService } from "@brainspore/celadon-base/modules/auth";

export default {
  name: "DeclarationComponent",
  mixins: [RouterMixin],
  data: function () {
    return {
      agree: false,
      isValid: false,
    };
  },
  mounted() {
    Event.$on("submitDeclaration", () => {
      this.$router.replace({
        name: "Payments",
        params: {
          app: btoa(this.application["applicationID"]),
        },
      });
      this.submit();
    });
    Event.$on("changeAppStatus", () => {
      this.$router.replace({
        name: "Payments",
        params: {
          app: btoa(this.application["applicationID"]),
        },
      });
    });
  },
  computed: {
    user() {
      // return this.$store.getters["Profile/bioData"];
      return AuthService.user;
    },
    rules() {
      return {
        required: [(v) => !!v || "field is required"],
      };
    },
    application() {
      return this.$store.getters["Application/appGetters"]("application");
    },
  },
  methods: {
    submit() {
      if (!this.isValid) {
        this.$refs.submitAppForm.validate();
      } else {
        this.$store.dispatch("Application/updateApplication", {
          profile_status: "application",
        });
      }
    },
  },
};
</script>
